import React, { useState } from 'react';
import App from './App'
import { loginRequest } from './authConfig';
import { callMsGraph } from './graph';
import { ProfileData } from './Components/Auth//ProfileData';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import Button from 'react-bootstrap/Button';
import { SignInPage } from "./Components/Auth/SignInPage";

/**
 * Renders the navbar component with a sign in or sign out button depending on whether or not a user is authenticated
 * @param props
 */

import './App.css';

/**
* Renders information about the signed-in user or a button to retrieve data about the user
*/
const ProfileContent = () => {
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState(null);
  
  function RequestProfileData() {
      // Silently acquires an access token which is then attached to a request for MS Graph data
      instance
          .acquireTokenSilent({
              ...loginRequest,
              account: accounts[0],
          })
          .then((response) => {
              return callMsGraph(response.accessToken).then((graphResponse) => setGraphData(graphResponse));
          })
          .catch((e) => {
              // Avoid unhandled promise rejections (MSAL and Graph can reject with non-Error objects)
              console.error('RequestProfileData failed', e);
          });
  }
  return (
      <>
          <h5 className="card-title">Welcome {accounts[0].name}</h5>
          <br/>
          {graphData ? (
              <ProfileData graphData={graphData} />
          ) : (
              <Button variant="secondary" onClick={RequestProfileData}>
                  Request Profile Information
              </Button>
          )}
      </>
  );
};

/**
* If a user is authenticated the ProfileContent component above is rendered. Otherwise a message indicating a user is not authenticated is rendered.
*/
const MainContent = () => {
  return (
      <div className="App">
          <AuthenticatedTemplate>
            <App />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <SignInPage />
          </UnauthenticatedTemplate>
      </div>
  );
};
export default function HandleLogin() {
  return (
    <MainContent />
  );
}